export default __webpack_public_path__ + "static/media/Benton-Sans-Wide-Medium.4e5a11be.otf";